export enum OfflineDetectActionType {
    OfflineChanged = 'OFFLINE_CHANGED',
    OfflineDataLoaded = 'OFFLINE_DATA_LOADED',
    ForceOfflineChanged = 'FORCE_OFFLINE_CHANGE'
};

export type OfflineDetectAction = {
    type: OfflineDetectActionType.OfflineChanged;
    payload: boolean;
} | {
    type: OfflineDetectActionType.ForceOfflineChanged;
    payload: boolean;
} | {
    type: OfflineDetectActionType.OfflineDataLoaded;
    payload: boolean;
};

export type OfflineDetectState = {
    offline: boolean;
    offlineDataLoaded: boolean;
    forceOffline: boolean | undefined;
};
